The value of `JobCategory.id` for the requested object.
